import type { RegisteredServices } from '@/core/container/types'

export const excludeProperties = [
  'category',
  'eventSource',
  'madeByAdmin',
  'firstName',
  'lastName',
  'phone',
  'userAvatarPath',
  'countryId',
]

export const switchSubAccountsTable = 'switchSubAccountsTable' as RegisteredServices
export const invoicesTableId = 'invoicesTable' as RegisteredServices

export const subAccountImportDetailsTable = 'subAccountImportDetailsTable' as RegisteredServices

export const subAccountDetailsSentSmsTableId = 'subAccountDetailsSentSmsTable' as RegisteredServices
export const subAccountDetailsReceivedSmsTableId = 'subAccountDetailsReceivedSmsTable' as RegisteredServices
export const statementsTableId = 'statementsTableId' as RegisteredServices

export const isEmptyPropertyValue = (property: string | null | undefined) => {
  return property === '' || property === null || property === undefined
}
